import CloseRounded from '@mui/icons-material/CloseRounded';
import GitHub from '@mui/icons-material/GitHub';
import LinkedIn from '@mui/icons-material/LinkedIn';
import Modal from '@mui/material/Modal';
import React from 'react'
import { motion, useReducedMotion } from 'framer-motion';
import styled from 'styled-components'
import { demoLabel, projectName } from '../../utils/projectHelpers';


const Container = styled.div`
width: 100%;
height: 100%;
position: absolute;
top: 0;
left: 0;
background-color: #000000a7;
backdrop-filter: blur(14px);
-webkit-backdrop-filter: blur(14px);
display: flex;
align-items: flex-start;
justify-content: center;
overflow-y: scroll;
transition: all 0.5s ease;
padding: 24px 12px;

@media only screen and (max-width: 600px) {
    padding: 0;
}
`;

const Wrapper = styled.div`
max-width: 800px;
width: 100%;
border-radius: 24px;
margin: 50px 12px;
height: min-content;
background:
  radial-gradient(circle at top right, rgba(56, 189, 248, 0.12), transparent 30%),
  ${({ theme }) => theme.card};
color: ${({ theme }) => theme.text_primary};
padding: 20px;
display: flex;
flex-direction: column;
position: relative;
border: 1px solid ${({ theme }) => theme.border};
box-shadow: 0 30px 90px ${({ theme }) => theme.shadow};

@media only screen and (max-width: 600px) {
    max-width: 100%;
    margin: 0;
    min-height: 100vh;
    border-radius: 0;
    padding: 16px;
}
`;

const Title = styled.h2`
  font-size: 28px;
  font-weight: 600;
  font-family: 'Instrument Sans', system-ui, sans-serif;
  color: ${({ theme }) => theme.text_primary};
  margin: 8px 6px 0px 6px;
  @media only screen and (max-width: 600px) {
      font-size: 24px;
      margin: 6px 6px 0px 6px;
  }
`;

const Date = styled.div`
    font-size: 16px;
    margin: 2px 6px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary};
    @media only screen and (max-width: 768px){
        font-size: 12px;
    }
`



const Desc = styled.div`
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary};
    margin: 8px 6px;
    @media only screen and (max-width: 600px) {
        font-size: 14px;
        margin: 6px 6px;
    }
`;

const Image = styled.img`
    width: 100%;
    max-height: 380px;
    object-fit: cover;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.border};
    margin-top: 30px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.3);

    @media only screen and (max-width: 600px) {
        margin-top: 18px;
        max-height: 220px;
        border-radius: 10px;
    }
`;

const Label = styled.h3`
    font-size: 20px;
    font-weight: 600;
    color: ${({ theme }) => theme.text_primary};
    margin: 8px 6px;
    @media only screen and (max-width: 600px) {
        font-size: 16px;
        margin: 8px 6px;
    }
`;

const Tags = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 8px 0px;
    @media only screen and (max-width: 600px) {
        margin: 4px 0px;
    }
`;

const Tag = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.primary};
    margin: 4px;
    padding: 4px 8px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.hover};
    border: 1px solid ${({ theme }) => theme.border};
    @media only screen and (max-width: 600px) {
        font-size: 12px;
    }
`;

const DetailGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin: 14px 6px;

    @media only screen and (max-width: 700px) {
        grid-template-columns: 1fr;
    }
`;

const DetailCard = styled.div`
    padding: 14px;
    border-radius: 14px;
    background: ${({ theme }) => theme.card_soft || theme.card};
    border: 1px solid ${({ theme }) => theme.border};
`;

const DetailTitle = styled.div`
    font-size: 14px;
    font-weight: 800;
    color: ${({ theme }) => theme.text_primary};
    margin-bottom: 8px;
`;

const DetailText = styled.div`
    font-size: 14px;
    line-height: 1.55;
    color: ${({ theme }) => theme.text_secondary};
`;

const HighlightList = styled.ul`
    margin: 10px 6px 4px;
    padding-left: 22px;
    color: ${({ theme }) => theme.text_secondary};
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const HighlightItem = styled.li`
    font-size: 14px;
    line-height: 1.5;
`;
const Members = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex-wrap: wrap;
    margin: 12px 6px;
    @media only screen and (max-width: 600px) {
        margin: 4px 6px;
    }
`;

const Member = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const MemberImage = styled.img`
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 50%;
    margin-bottom: 4px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.3);
    @media only screen and (max-width: 600px) {
        width: 32px;
        height: 32px;
    }
`;

const MemberName = styled.div`
    font-size: 16px;
    font-weight: 500;
    width: 200px;
    color: ${({ theme }) => theme.text_primary};
    @media only screen and (max-width: 600px) {
        font-size: 14px;
    }
`;


const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 12px 0px;
    gap: 12px;

    @media only screen and (max-width: 600px) {
        flex-direction: column;
        justify-content: stretch;
        gap: 10px;
    }
`;

const Button = styled.a`
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: var(--button-text);
    padding: 12px 16px;
    border-radius: 14px;
    background: var(--button-bg);
    ${({ $dull, theme }) => $dull && `
        background: ${theme.card_soft};
        color: ${theme.text_secondary};
        &:hover {
          background-color: ${theme.hover};
        }
    `}
    cursor: pointer;
    text-decoration: none;
    transition: all 0.5s ease;
    &:hover {
        filter: brightness(1.06);
    }
    @media only screen and (max-width: 600px) {
        font-size: 14px;
        padding: 12px 14px;
    }
`;


const CloseButton = styled.button`
    align-self: flex-end;
    position: sticky;
    top: 0;
    z-index: 1;
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid var(--border);
    color: var(--text);
    background: var(--surface);
    cursor: pointer;
`;
const Screenshot = styled.img`
    width: 100%;
    max-height: 520px;
    object-fit: contain;
    border-radius: 12px;
    margin-top: 12px;
    background: var(--surface-soft);
`;

export default function ProjectDetails({ openModal, setOpenModal }) {
    const reducedMotion = useReducedMotion();
    const project = openModal?.project;
    if (!project) return null;
    const close = () => setOpenModal({ state: false, project: null });
    const name = projectName(project);
    const demo = demoLabel(project.webAppLink);
    const sections = [
        ['System Architecture', project.architecture],
        ['Implementation Challenges', project.challenges],
    ];
    return (
        <Modal open={openModal.state} onClose={close}>
            <Container onClick={event => { if (event.target === event.currentTarget) close(); }}>
                <Wrapper as={motion.div} initial={reducedMotion ? false : { opacity: 0, y: 12, scale: 0.985 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: reducedMotion ? 0 : 0.22 }} role="dialog" aria-modal="true" aria-labelledby="project-title" aria-describedby="project-overview" tabIndex={-1}>
                    <CloseButton type="button" onClick={close} aria-label="Close project case study"><CloseRounded /></CloseButton>
                    <Title id="project-title">{name}</Title>
                    <Date>{project.status || project.category}</Date>
                    <Label>Project Overview</Label>
                    <Desc id="project-overview">{project.detailedDescription || project.description}</Desc>
                    {project.imageVerified && <Image src={project.image} alt={name + ' application screenshot'} width={1520} height={855} decoding="async" />}
                    <Label>Technology Stack</Label>
                    <Tags>{(project.technologies || []).map(tag => <Tag key={tag}>{tag}</Tag>)}</Tags>
                    {(project.problem || project.solution) && <DetailGrid>
                        {project.problem && <DetailCard><DetailTitle>Problem</DetailTitle><DetailText>{project.problem}</DetailText></DetailCard>}
                        {project.solution && <DetailCard><DetailTitle>Solution</DetailTitle><DetailText>{project.solution}</DetailText></DetailCard>}
                    </DetailGrid>}
                    {project.highlights?.length > 0 && <><Label>Key Features</Label><HighlightList>{project.highlights.map(item => <HighlightItem key={item}>{item}</HighlightItem>)}</HighlightList></>}
                    {sections.filter(([, items]) => items?.length).map(([heading, items]) => <section key={heading}><Label>{heading}</Label><HighlightList>{items.map(item => <HighlightItem key={item}>{item}</HighlightItem>)}</HighlightList></section>)}
                    {project.evaluation && <><Label>Research Evaluation</Label><Desc>{project.evaluation}</Desc></>}
                    {project.screenshots?.length > 0 && <><Label>Screenshots</Label>{project.screenshots.map(shot => <figure key={shot.src}><a href={shot.src} target="_blank" rel="noopener noreferrer" aria-label={'Open screenshot: ' + shot.alt}><Screenshot src={shot.src} alt={shot.alt} loading="lazy" decoding="async" /></a><figcaption style={{ padding: '8px 6px', fontSize: 13 }}>{shot.alt}</figcaption></figure>)}</>}
                    {project.member?.length > 0 && <><Label>Members</Label><Members>{project.member.map(member => <Member key={member.name}><MemberImage src={member.img} alt={member.name} /><MemberName>{member.name}</MemberName>{member.github && <a href={member.github} target="_blank" rel="noopener noreferrer" aria-label={member.name + ' GitHub'}><GitHub /></a>}{member.linkedin && <a href={member.linkedin} target="_blank" rel="noopener noreferrer" aria-label={member.name + ' LinkedIn'}><LinkedIn /></a>}</Member>)}</Members></>}
                    {project.sources?.length > 0 && <><Label>Project Documentation</Label><HighlightList>{project.sources.map(source => <HighlightItem key={source.url}><a style={{ color: 'var(--accent)' }} href={source.url} target="_blank" rel="noopener noreferrer">{source.label}</a></HighlightItem>)}</HighlightList></>}
                    <ButtonGroup>
                        {project.githubLink && <Button $dull href={project.githubLink} target="_blank" rel="noopener noreferrer">GitHub Repository</Button>}
                        {demo && <Button href={project.webAppLink} target="_blank" rel="noopener noreferrer">{demo}</Button>}
                    </ButtonGroup>
                </Wrapper>
            </Container>
        </Modal>
    );
}
